import { NotificationContentType } from "@features/notifications/domain";

export const validNotificationTypes = [
  NotificationContentType.PRODUCT_LOCK_QUANTITY_EXPIRING,
  NotificationContentType.PRODUCT_LOCK_TIME_EXPIRING,
  NotificationContentType.PRODUCT_LOCK_REMOVED,
  NotificationContentType.PRODUCT_LOCK_CREATED,
  NotificationContentType.PRODUCT_LOCK_UPDATED,
  NotificationContentType.RECOMMENDATION_CREATED,
];
